module.exports = __webpack_public_path__ + "static/media/bitcoin.709e83ea.png";